<footer>
    <p class="copyright">
        <a href="https://github.com/brdppl" target="_blank">
            {{currentYear}} &copy; Feito com <fa-icon [icon]="faHeart"></fa-icon> por <span>Bernardo Sampaio</span>
        </a>
    </p>
</footer>